import React from 'react';

import { useTranslation } from 'react-i18next';

import { OPTIONS_COMBOS_SPREAD_LINK } from 'constants/constants';
import { useWindowSize } from 'hooks';
import { LearnMoreIcon } from 'styles/assets/icons';

import desktopstyles from './Desktop/style.module.scss';
import mobilestyles from './Mobile/style.module.scss';

const OptionsCombosDesktopSlideAdditionalElement = () => {
  const { t } = useTranslation(['account']);
  const { isMobile } = useWindowSize();
  const styles = isMobile ? mobilestyles : desktopstyles;

  return (
    (<a
      data-testid="rowThreeAdditionalElement"
      href={OPTIONS_COMBOS_SPREAD_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.sixthSlideAdditionalText}
      data-palette="OptionsCombosDesktopSlideAdditionalElement">
      {t('account:learnMore').toLowerCase()}
      <LearnMoreIcon height={16} width={16} />
    </a>)
  );
};

export default OptionsCombosDesktopSlideAdditionalElement;
